import React from "react";

export default function ErrorText(props: { error: string }) {
    return (
        <p style={{ color: "red", textAlign: "right" }}>
            <b>{props.error}</b>
        </p>
    );
}
